import React from 'react';
import PropTypes from 'prop-types';
import {Accordion} from 'semantic-ui-react';

const EventsStaticContentPanel = ({children, id, title}) => (
    <Accordion fluid styled className='eventContent' id={id}>
        <Accordion.Title active className='eventContent__title--static'>
            {title}
        </Accordion.Title>
        <Accordion.Content active>
            {children}
        </Accordion.Content>
    </Accordion>
);

EventsStaticContentPanel.propTypes = {
    children: PropTypes.node.isRequired,
    id: PropTypes.string.isRequired,
    title: PropTypes.node.isRequired,
};

export default EventsStaticContentPanel;
